// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__zc97X","top":"Header_top__x6BmF","burger":"Header_burger__3_mhY"};